export default {
    url: '/general',
    template: '<manage-settings-general company="vm.company"><manage-settings-general/>',
    resolve: {
        company (CompanyResource, TokenService) {
            return CompanyResource.get({ id: TokenService.getCompanyId(), expand: 'languages' }).$promise;
        }
    },
    controller (company) {
        this.company = company;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/manage/settings/general/index.js